<template>
  <div>

    <v-card elevation=0 outlined>
      <v-card-title>Totais</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="2">
            Usuários: {{ totals.user_count }}
          </v-col>
          <v-col cols="2"> Custo Total: {{ totals.total_cost }}
          </v-col>
          <v-col cols="2"> Número de Requisições: {{ totals.request_count }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2"> Tokens de Entrada: {{ totals.total_input_tokens }}
          </v-col>
          <v-col cols="2"> Tokens de Saída: {{ totals.total_output_tokens }}
          </v-col>
          <v-col cols="2"> Total de Tokens: {{ totals.total_tokens_sum }}
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>


    <v-row>
      <v-col>
        <app-pagination @click="select($event)" :data="report">
          <br />
          <v-data-table dense :headers="headers" :items="report.data" :items-per-page="-1" hide-default-footer
            disable-sort>

            <template v-slot:[`item.user`]="{ item }">
              <div class="d-flex flex-column">
                <span>
                  {{ item.user.name }}
                </span>
                <small class="text--secondary">
                  {{ `${item.company_id} - ${item.company.name}` }}
                </small>
              </div>
            </template>
            <template v-slot:[`item.ia_credits`]="{ item }">
              {{ item.user.ia_credits }}
            </template>

            <template v-slot:[`item.ia_used_credits`]="{ item }">
              {{ item.user.ia_used_credits }}
            </template>


          </v-data-table>
        </app-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {

      report: {
        data: [],
      },
      totals: {},


      headers: [
        { text: "Usuário", value: "user", align: "start" },
        { text: "Cota Mensal", value: "ia_credits", align: "start" },
        { text: "Credito Usado", value: "ia_used_credits", align: "start" },

        { text: "Custo Aprox", value: "total_cost", align: "end" },
        { text: "Token. Entrada", value: "total_input_tokens", align: "end" },
        { text: "Token. Saída", value: "total_output_tokens", align: "end" },
        { text: "Tot. Tokens", value: "total_tokens_sum", align: "end" },
        { text: "Nº Requisições", value: "request_count", align: "end" },

      ],

    };
  },

  mounted() {
    this.select();
  },

  methods: {
    select(page) {

      this.$http.index('admin/ia-usage', { page: page }).then(response => {

        this.report = response.report
        this.totals = response.totals

      }).catch(error => {
        console.error('Error fetching IA usage data:', error);
      });
    },


  },
};
</script>

<style></style>
